import { useSelector } from 'react-redux';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import Discover from './Discover';
import Company from './Company';
import Policies from './Policies';
import Privacy from './Privacy';
import Communities from './Communities';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const OtherSection = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const isForumDisabled = useSelector(getIsFeatureSwitchEnabled('disable_forum_web'));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Discover, {
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    }), /*#__PURE__*/_jsx(Company, {}), /*#__PURE__*/_jsx(Policies, {
      impressumUrl: impressumUrl,
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    }), /*#__PURE__*/_jsx(Privacy, {}), !isForumDisabled && /*#__PURE__*/_jsx(Communities, {})]
  });
};

export default OtherSection;